import { Box, Button, ButtonGroup, Text } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import {
  AdaptedSelect,
  DropzoneControl,
  InputControl,
  Optional,
  TextareaControl,
} from "../components/Form";
import { Loader } from "../components/Loader";
import { AccountRole, LanguageCode, useLanguagesQuery } from "../graphql";

export interface INotifyAllFormValues {
  title: string;
  role: AccountRole;
  body: string;
  languageCode: LanguageCode;
  externalURL?: string;
}

interface INotifyAllForm {
  onSubmit: (values: INotifyAllFormValues) => void;
  initialValues?: Optional<INotifyAllFormValues>;
}

export const NotifyAllForm: React.FC<INotifyAllForm> = React.memo(
  ({ onSubmit, initialValues }) => {
    const validate = (values) => {
      const errors: { [key: string]: string } = {};

      if (!values.title) {
        errors.title = "Fushë e detyruar";
      }

      if (!values.role) {
        errors.title = "Fushë e detyruar";
      }

      if (!values.body) {
        errors.body = "Fushë e detyruar";
      }

      if (!values.languageCode) {
        errors.languageCode = "Fushë e detyruar";
      }

      return errors;
    };

    const { loading, data } = useLanguagesQuery({});

    const languages = data?.languages;

    if (loading) {
      return <Loader></Loader>;
    }

    return (
      <Form
        onSubmit={onSubmit}
        validate={validate}
        initialValues={initialValues}
        render={({
          handleSubmit,
          form,
          errors,
          submitting,
          pristine,
          values,
        }) => (
          <Box as="form" p={2} onSubmit={handleSubmit}>
            <Field name="languageCode" component={AdaptedSelect} label="Gjuha">
              {languages.map((item) => (
                <option value={item.code}>{item.name}</option>
              ))}
            </Field>
            <Field name="role" component={AdaptedSelect} label="Roli">
              <option value={AccountRole.Client}>Klient</option>
              <option value={AccountRole.Doctor}>Mjek i përgjithshëm</option>
              <option value={AccountRole.MedicalSpecialist}>
                Mjek specialist
              </option>
            </Field>
            <InputControl name="title" label="Titulli" />
            <TextareaControl name="body" label="Përmbajtja" />
            <InputControl name="externalURL" label="Adresa URL" />

            <ButtonGroup spacing={4}>
              <Button
                isLoading={submitting}
                loadingText="Duke dërguar"
                variantColor="teal"
                type="submit"
              >
                Dërgo
              </Button>
              <Button
                variantColor="teal"
                variant="outline"
                onClick={form.reset}
                isDisabled={submitting || pristine}
              >
                Pastro
              </Button>
            </ButtonGroup>
          </Box>
        )}
      />
    );
  }
);
